"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FormDatosFiscalesTest = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _style = _interopRequireDefault(require("./style"));

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class FormDatosFiscalesTest extends _react.default.Component {
  constructor(props) {
    super(props);
    this.handleChangeFields = this.handleChangeFields.bind(this);
  }

  componentDidMount() {
    //guarda estos datos al principio para guardar los datos de email y telefono del paso de contactos
    //en caso de que ya tenga esos datos simplemente guarda los mismos que ya tenia
    if (this.props.email_facturacion) {
      this.props.onChange(this.props.email_facturacion, 'email_facturacion');
    }

    if (this.props.telefono_facturacion) {
      this.props.onChange(this.props.telefono_facturacion, 'telefono_facturacion');
    }
  }

  handleChangeFields(event) {
    this.props.onChange(event.target.value, event.target.name);
  }

  render() {
    const {
      razon_social,
      codigo_unico,
      tipo_codigo_unico,
      email_facturacion,
      telefono_facturacion
    } = this.props;
    return (0, _react2.jsx)("div", null, (0, _react2.jsx)(_material.Box, {
      mt: 2
    }, (0, _react2.jsx)(_material.Box, {
      mb: 2,
      mt: 2
    }, (0, _react2.jsx)(_material.Typography, {
      variant: "h6"
    }, "Datos Fiscales")), (0, _react2.jsx)(_material.Grid, {
      container: true,
      justify: "space-between"
    }, (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, (0, _react2.jsx)(_material.TextField, {
      variant: "standard",
      label: "Nombre Completo o Raz\xF3n Social",
      name: "razon_social",
      defaultValue: razon_social,
      onBlur: e => this.handleChangeFields(e),
      css: _style.default.separacion
    })), (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 4,
      sm: 2
    }, (0, _react2.jsx)(_material.FormControl, {
      css: _style.default.separacion
    }, (0, _react2.jsx)(_material.TextField, {
      select: true,
      variant: "standard",
      label: "CUIT/CUIL",
      value: tipo_codigo_unico ? tipo_codigo_unico : [],
      name: "tipo_codigo_unico",
      onChange: e => this.handleChangeFields(e)
    }, (0, _react2.jsx)(_material.MenuItem, {
      value: 1
    }, "CUIT"), (0, _react2.jsx)(_material.MenuItem, {
      value: 2
    }, "CUIL")))), (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 8,
      sm: 4
    }, (0, _react2.jsx)(_material.TextField, {
      label: "N\xFAmero",
      variant: "standard",
      type: "text",
      name: "codigo_unico",
      defaultValue: codigo_unico,
      onBlur: e => this.handleChangeFields(e),
      css: _style.default.separacion
    })), (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, (0, _react2.jsx)(_material.TextField, {
      variant: "standard",
      label: "Email para facturaci\xF3n",
      type: "text",
      name: "email_facturacion",
      defaultValue: email_facturacion,
      onBlur: e => this.handleChangeFields(e),
      css: _style.default.separacion
    })), (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, (0, _react2.jsx)(_material.TextField, {
      variant: "standard",
      label: "Tel\xE9fono para facturaci\xF3n",
      type: "text",
      name: "telefono_facturacion",
      defaultValue: telefono_facturacion,
      onBlur: e => this.handleChangeFields(e),
      css: _style.default.separacion
    })))));
  }

}

exports.FormDatosFiscalesTest = FormDatosFiscalesTest;
var _default = FormDatosFiscalesTest;
exports.default = _default;